import { FC, Fragment } from "react";
import { Button, Stack, Typography } from "@mui/material";
import { FilterValueWithBatchInputAlert } from "@/components/pages/common/filters-tree/filters-selection/components/provider-dynamic-filters/filter-item/components/filter-value/components/filter-value-with-batch-input/components/FilterValueWithBatchInputAlert";
import { FilterValueWithBatchInputTextArea } from "@/components/pages/common/filters-tree/filters-selection/components/provider-dynamic-filters/filter-item/components/filter-value/components/filter-value-with-batch-input/components/FilterValueWithBatchInputTextArea";
import { FilterValueWithBatchInputActions } from "@/components/pages/common/filters-tree/filters-selection/components/provider-dynamic-filters/filter-item/components/filter-value/components/filter-value-with-batch-input/components/FilterValueWithBatchInputActions";

interface FilterValueWithBatchInputPopoverFinalPhaseProps {
  text: string;
  onClose(): void;
  batchValues: string[];
  validValues: string[];
  onValuesEnter(): void;
  enteredValuesCount: number;
  setText(text: string): void;
  onValueApply(): void;
}

export const FilterValueWithBatchInputPopoverFinalPhase: FC<
  FilterValueWithBatchInputPopoverFinalPhaseProps
> = ({
  batchValues,
  enteredValuesCount,
  validValues,
  text,
  setText,
  onClose,
  onValueApply,
  onValuesEnter,
}) => {
  return (
    <Fragment>
      {!!batchValues.length && (
        <Stack bgcolor="grey.100" p={1.5} borderRadius={2} spacing={1}>
          <FilterValueWithBatchInputAlert count={batchValues.length} />

          <FilterValueWithBatchInputTextArea value={text} onChange={setText} />

          {!!enteredValuesCount && (
            <Typography variant="caption" pl={1}>
              You have entered {enteredValuesCount} value
              {enteredValuesCount > 1 ? "s" : ""}.
            </Typography>
          )}
        </Stack>
      )}

      <Stack p={1.5} spacing={1} bgcolor="grey.100" borderRadius={2}>
        <FilterValueWithBatchInputAlert valid count={validValues.length} />

        <Stack
          spacing={0.5}
          direction="row"
          flexWrap="wrap"
          bgcolor="grey.100"
          maxHeight={200}
          overflow="auto"
        >
          {validValues.map((id) => (
            <Typography variant="body2" key={id}>
              {id},
            </Typography>
          ))}
        </Stack>
      </Stack>

      {batchValues.length ? (
        <FilterValueWithBatchInputActions
          variant="outlined"
          onClose={onClose}
          onSubmit={onValuesEnter}
          submitLabel="Retry Search"
          disabled={!enteredValuesCount}
        >
          <Button
            size="small"
            color="primary"
            variant="contained"
            onClick={onValueApply}
          >
            Apply Found Values
          </Button>
        </FilterValueWithBatchInputActions>
      ) : (
        <FilterValueWithBatchInputActions
          variant="contained"
          submitLabel="Apply"
          onClose={onClose}
          onSubmit={onValueApply}
        />
      )}
    </Fragment>
  );
};
